import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation } from "react-router-dom";

import SparePartProductsListContainer from "containers/SparePart/ProductsListContainer.jsx";
import GroupedProductsContainer from "containers/GroupedProductsContainer.jsx";
import FilterPillContainer from "containers/FilterPillContainer.jsx";

import {
  getGroupByProducts,
  resetGroupedProducts
} from "actions/groupByProductsActions.js";

import { selectedGroupByFilterSelector } from "selectors/groupedProductsSelector.js";
import {
  fetchedDynamicFiltersSelector,
  appliedDynamicFiltersSelector,
  appliedCommonFiltersSelector
} from "selectors/filtersSelector.js";
import { warehouseIdSelector } from "selectors/warehouseSelector.js";
import { buyplanIdSelector } from "selectors/buyplanIdSelector.js";

import { CATALOGUE_ORDER, PER_PAGE } from "constants.js";

const SparePartRangeContainer = () => {
  const { releaseId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const buyPlanState = queryParams.get("type");
  const buyplanId = useSelector(buyplanIdSelector);
  const warehouseId = useSelector(warehouseIdSelector);

  const selectedGroupByFilter = useSelector(
    selectedGroupByFilterSelector
  ).toJS();
  const groupByFilter = selectedGroupByFilter.value;
  const appliedFilters = useSelector(appliedDynamicFiltersSelector);
  const appliedCommonFilters = useSelector(appliedCommonFiltersSelector);
  const fetchedFilters = useSelector(fetchedDynamicFiltersSelector);

  useEffect(() => {
    if (groupByFilter !== CATALOGUE_ORDER) {
      dispatch(
        getGroupByProducts(
          releaseId,
          PER_PAGE,
          0,
          true,
          buyPlanState,
          buyplanId,
          groupByFilter
        )
      );
      return () => {
        dispatch(resetGroupedProducts());
      };
    }
  }, [
    dispatch,
    releaseId,
    buyPlanState,
    buyplanId,
    appliedFilters,
    appliedCommonFilters,
    warehouseId,
    groupByFilter
  ]);

  // The release default grouping is kept even when it has no data (e.g. an
  // empty catalog), so fall back to the ungrouped list rather than crashing.
  const availableGroups = groupByFilter && fetchedFilters.get(groupByFilter);

  if (groupByFilter === CATALOGUE_ORDER || !(availableGroups && availableGroups.size > 0)) {
    return (
      <>
        <FilterPillContainer />
        <SparePartProductsListContainer />
      </>
    );
  } else {
    if (groupByFilter) {
      let subcategoryFilters = [];

      if (
        appliedFilters &&
        appliedFilters.get(groupByFilter) &&
        appliedFilters.get(groupByFilter).size > 0
      ) {
        subcategoryFilters = appliedFilters.get(groupByFilter);
      } else {
        availableGroups.forEach(filterOption => {
          const isExistingFilterOption = subcategoryFilters.find(option => {
            return option.get("name") === filterOption.get("name");
          });

          isExistingFilterOption === undefined &&
            subcategoryFilters.push(filterOption);
        });
      }

      return subcategoryFilters.map((value, index) => {
        return (
          <GroupedProductsContainer
            key={index}
            groupName={value.get("name")}
            groupByFilter={groupByFilter}
          />
        );
      });
    }
  }
};

export default React.memo(SparePartRangeContainer);
